<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="挑战赛名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入挑战赛名称" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['challenge:challenge:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['challenge:challenge:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['challenge:challenge:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
<!--      <rank-form-->
<!--        ref="rankForm"-->
<!--      />-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 500px)'}" 
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}} 
        </span>
        <!-- <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime,'{y}-{m}-{d}') }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime,'{y}-{m}-{d}') }}
        </span> -->
        <span slot="startTime" slot-scope="text, record">
         <p>{{ parseTime(record.startTime) }}</p>
         <p>{{ parseTime(record.endTime) }}</p> 
       
        </span>
        <span slot="scoreVoucher" slot-scope="text, record">
          <p>{{record.scoreVoucher}}</p> 
         <p>{{record.needVoucher}}</p>
        
       
        </span>
        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.logo"
                :src="record.logo" preview="头像"/>
        </span>

        <span slot="operation" slot-scope="text, record, index">
       <!--  <a @click="$refs.rankForm.handleUpdate(record, undefined)" v-hasPermi="['challenge:challenge:edit']">
           <a-icon type="user" />排行展示
         </a> -->
           <a  @click="viewRanking(record)" v-hasPermi="['challenge:challenge:viewRanking']">
          <a-icon type="search" />排名
        </a>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['challenge:challenge:edit']">
            <a-icon type="edit" />修改
          </a>
          <br>
          <a @click="handleDelete(record, index)" v-hasPermi="['challenge:challenge:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageChallenge,listChallenge, delChallenge } from '@/api/challenge/challenge'
import CreateForm from './modules/CreateForm'
import RankForm from './rank'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Challenge',
  components: {
    CreateForm,
    RankForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
       //索引indexs
      indexs: [], 
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        name: null,
        logo: null,
        startTime: null,
        endTime: null,
        activityDescription: null,
        winningDescription: null,
        joinCondition: null,
        ruleConfig: null,
        peopleNum: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,                    
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: '挑战赛编号',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'logo',
          dataIndex: 'logo',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 0){
              return '未开始'
            }else if(f == 1){
              return '进行中'
            }else{
              return '已结束'
            }
          }
        },
        {
          title: '活动时间',
          dataIndex: 'startTime',
          scopedSlots: { customRender: 'startTime' },
          // ellipsis: true,
          width:180,
          align: 'center'
        },
        // {
        //   title: '开始时间',
        //   dataIndex: 'startTime',
        //   scopedSlots: { customRender: 'startTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '截止时间',
        //   dataIndex: 'endTime',
        //   scopedSlots: { customRender: 'endTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '活动说明',
        //   dataIndex: 'activityDescription',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '中奖说明',
        //   dataIndex: 'winningDescription',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '参与人数',
          dataIndex: 'peopleNum',
          ellipsis: true,
          align: 'center'
        },
        
        {
          title: '积分数',
          dataIndex: 'needScore',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '积分+现金券',
          dataIndex: 'scoreVoucher',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'needVoucher' },
        },
        // {
        //   title: '积分金券',
        //   dataIndex: 'scoreVoucher',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 130,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询挑战赛列表 */
    getList () {
      this.loading = true
     pageChallenge(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
    // 查看排名
    viewRanking(record){
      this.$router.push({path: '/challenge/challenge/rank',query : { id : record.id} })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        logo: undefined,
        startTime: undefined,
        endTime: undefined,
        activityDescription: undefined,
        winningDescription: undefined,
        joinCondition: undefined,
        ruleConfig: undefined,
        peopleNum: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
        // 列表顶部删除indexs
        if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1   
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delChallenge(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('challenge/challenge/export', {
            ...that.queryParam
          }, `挑战赛_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
